
import "./internal.css";

import { useState, useEffect } from "react";

/* rotas do cloud run */
import { ENDPOINTS } from "../../routes/endpoints.js";



export default function Report() {

    const [loadBox1, setLoadBox1] = useState(true);
    const [loadBox2, setLoadBox2] = useState(true);

    const [box1, setBox1] = useState({lp_us: 0, lp_vs: 0, home_us: 0, home_vs: 0, funciona_us: 0, funciona_vs: 0, plano_us: 0, plano_vs: 0, login_us: 0, login_vs: 0, cadastro_us: 0, cadastro_vs: 0, termos_us: 0, termos_vs: 0});
    const [box2, setBox2] = useState({clientes: 0, agentes: 0, st1: 0, st2: 0, st3: 0, st4: 0, st5: 0, st6: 0, st7: 0, st8: 0, linhas: 0, ln1: 0, ln2: 0});
    const [box3, setBox3] = useState({menu_funciona_us: 0, menu_funciona_vs: 0, menu_beneficio_us: 0, menu_beneficio_vs: 0, menu_quem_us: 0, menu_quem_vs: 0, menu_faq_us: 0, menu_faq_vs: 0, botao_testarmenu_us: 0, botao_testarmenu_vs: 0, botao_testarform_us: 0, botao_testarform_vs: 0});





    useEffect(() => {

        async function loadBox1() {

            try {

                const response = await fetch(ENDPOINTS.report.sales_pages);

                const dados = await response.json();

                const lp = dados.find(item => item.pagina === "/lp");
                const home = dados.find(item => item.pagina === "/");
                const funciona = dados.find(item => item.pagina === "/howitworks");
                const plano = dados.find(item => item.pagina === "/subscription");
                const login = dados.find(item => item.pagina === "/login");
                const cadastro = dados.find(item => item.pagina === "/register");
                const termos = dados.find(item => item.pagina === "/terms");

                setBox1({
                    lp_us: lp?.usuarios ?? 0, lp_vs: lp?.visualizacoes ?? 0, 
                    home_us: home?.usuarios ?? 0, home_vs: home?.visualizacoes ?? 0, 
                    funciona_us: funciona?.usuarios ?? 0, funciona_vs: funciona?.visualizacoes ?? 0, 
                    plano_us: plano?.usuarios ?? 0, plano_vs: plano?.visualizacoes ?? 0, 
                    login_us: login?.usuarios ?? 0, login_vs: login?.visualizacoes ?? 0,
                    cadastro_us: cadastro?.usuarios ?? 0, cadastro_vs: cadastro?.visualizacoes ?? 0,
                    termos_us: termos?.usuarios ?? 0, termos_vs: termos?.visualizacoes ?? 0
                });

                const responselp = await fetch(ENDPOINTS.report.sales_events);

                const dadoslp = await responselp.json();

                const menu_funciona = dadoslp.find(item => item.evento === "lp_menu_click" && item.menu === "funciona");
                const menu_beneficio = dadoslp.find(item => item.evento === "lp_menu_click" && item.menu === "beneficio");
                const menu_quem = dadoslp.find(item => item.evento === "lp_menu_click" && item.menu === "quem");
                const menu_faq = dadoslp.find(item => item.evento === "lp_menu_click" && item.menu === "faq");

                const botao_menu = dadoslp.find(item => item.evento === "lp_button_click" && item.button === "testar_menu");
                const botao_form = dadoslp.find(item => item.evento === "lp_button_click" && item.button === "testar_form");

                setBox3({
                    menu_funciona_us: menu_funciona?.usuarios ?? 0, menu_funciona_vs: menu_funciona?.quantidade ?? 0,
                    menu_beneficio_us: menu_beneficio?.usuarios ?? 0, menu_beneficio_vs: menu_beneficio?.quantidade ?? 0,
                    menu_quem_us: menu_quem?.usuarios ?? 0, menu_quem_vs: menu_quem?.quantidade ?? 0,
                    menu_faq_us: menu_faq?.usuarios ?? 0, menu_faq_vs: menu_faq?.quantidade ?? 0,
                    botao_testarmenu_us: botao_menu?.usuarios ?? 0, botao_testarmenu_vs: botao_menu?.quantidade ?? 0,
                    botao_testarform_us: botao_form?.usuarios ?? 0, botao_testarform_vs: botao_form?.quantidade ?? 0,
                });


            } catch (error) {
                console.error("Erro ao carregar relatório:", error);
            } finally {
                setLoadBox1(false);
            }

        }

        async function loadBox2() {

            try {

                const response = await fetch(ENDPOINTS.report.clients);

                const dados = await response.json();

                const clientes = dados.clientes;
                const agentes = dados.agentes;
                const status = dados.agentes_status;
                const linhas = dados.linhas;
                const status_linhas = dados.linhas_status;

                setBox2({
                    clientes: clientes ?? 0,
                    agentes: agentes ?? 0,
                    linhas: linhas ?? 0,
                    st1: status?.["1"] ?? 0,
                    st2: status?.["2"] ?? 0,
                    st3: status?.["3"] ?? 0,
                    st4: status?.["4"] ?? 0,
                    st5: status?.["5"] ?? 0,
                    st6: status?.["6"] ?? 0,
                    st7: status?.["7"] ?? 0,
                    st8: status?.["8"] ?? 0,
                    ln1: status_linhas?.["1"] ?? 0,
                    ln2: status_linhas?.["2"] ?? 0
                });

            } catch (error) {
                console.error("Erro ao carregar relatório:", error);
            } finally {
                setLoadBox2(false);
            }

        }

        loadBox1();
        loadBox2();

    }, []);


    return(
        <div className="report_context">

            <span className="space"></span>

            <span className="report_title">WINNERS-AI</span>
            <span className="space_form"></span>
            <span className="report_topic">Report</span>

            <span className="space"></span>

            <div className="report_group">
                <div className="report_group1_space"></div>
                <div className="report_box1">
                    <span className="report_group1_label">Criativo 1</span>
                    <span className="report_group1_number">0</span>
                </div>
                <div className="report_group1_space"></div>
                <div className="report_box1">
                    <span className="report_group1_label">Criativo 2</span>
                    <span className="report_group1_number">0</span>
                </div>
                <div className="report_group1_space"></div>
                <div className="report_box1">
                    <span className="report_group1_label">Criativo 3</span>
                    <span className="report_group1_number">0</span>
                </div>
                <div className="report_group1_space"></div>
                <div className="report_box1">
                    <span className="report_group1_label">Criativo 4</span>
                    <span className="report_group1_number">0</span>
                </div>
                <div className="report_group1_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group2_space"></div>
                <div className="report_box2">
                    { loadBox1 ? (<><span>carregando ...</span></>) :
                    (<>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_label">
                        <span className="report_box2_label_text">Landing Page</span>
                        <span className="report_box2_label_description">qtde. usuários</span>
                        <span className="report_box2_label_description">(qtde. acessos)</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_number">
                        <span className="report_box2_item_label" style={{fontWeight: "bold"}}>Home<br /><br /></span>
                        <span className="report_box2_item_usuario">{box1.lp_us}</span>
                        <span className="report_box2_item_visualizacao">({box1.lp_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">Funciona<br />(menu)</span>
                        <span className="report_box2_item_usuario">{box3.menu_funciona_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.menu_funciona_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">Beneficio<br />(menu)</span>
                        <span className="report_box2_item_usuario">{box3.menu_beneficio_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.menu_beneficio_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">Pra Quem<br />(menu)</span>
                        <span className="report_box2_item_usuario">{box3.menu_quem_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.menu_quem_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">FAQ<br />(menu)</span>
                        <span className="report_box2_item_usuario">{box3.menu_faq_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.menu_faq_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">Menu<br />(botão)</span>
                        <span className="report_box2_item_usuario">{box3.botao_testarmenu_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.botao_testarmenu_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item">
                        <span className="report_box2_item_label">Formulario<br />(botão)</span>
                        <span className="report_box2_item_usuario">{box3.botao_testarform_us}</span>
                        <span className="report_box2_item_visualizacao">({box3.botao_testarform_vs})</span>
                    </div>
                    <div className="report_box2_space"></div>
                    <div className="report_box2_item"></div>
                    <div className="report_box2_space"></div>
                    </>)}
                </div>
                <div className="report_group2_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group3_space"></div>
                <div className="report_box3">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                <div className="report_group3_boxA">
                    <div className="report_group3_boxA_label">
                        <span className="report_group3_boxA_label_title">Plataforma</span>
                        <span className="report_group3_boxA_label_description">qtde. usuários (qtde. acessos)</span>
                    </div>
                    <div className="report_group3_boxA_space"></div>
                    <div className="report_group3_boxA_box">
                        <span className="report_group3_boxA_box_qtde1">{box1.home_us}</span>
                        <span className="report_group3_boxA_box_qtde2">({box1.home_vs})</span>
                    </div>
                    <div className="report_group3_boxA_space"></div>
                </div>
                <div className="report_group3_boxB">
                    <div className="report_group3_boxB_space"></div>
                    <div className="report_group3_boxB_box">
                        <span className="report_group3_boxB_box_label">/Funciona</span>
                        <span className="report_group3_boxB_box_qtde1">{box1.funciona_us}</span>
                        <span className="report_group3_boxB_box_qtde2">({box1.funciona_vs})</span>
                    </div>
                    <div className="report_group3_boxB_space"></div>
                    <div className="report_group3_boxB_box">
                        <span className="report_group3_boxB_box_label">/Planos</span>
                        <span className="report_group3_boxB_box_qtde1">{box1.plano_us}</span>
                        <span className="report_group3_boxB_box_qtde2">({box1.plano_vs})</span>
                    </div>
                    <div className="report_group3_boxB_space"></div>
                    <div className="report_group3_boxB_box">
                        <span className="report_group3_boxB_box_label">/Login</span>
                        <span className="report_group3_boxB_box_qtde1">{box1.login_us}</span>
                        <span className="report_group3_boxB_box_qtde2">({box1.login_vs})</span>
                    </div>
                    <div className="report_group3_boxB_space"></div>
                    <div className="report_group3_boxB_box">
                        <span className="report_group3_boxB_box_label">/Cadastro</span>
                        <span className="report_group3_boxB_box_qtde1">{box1.cadastro_us}</span>
                        <span className="report_group3_boxB_box_qtde2">({box1.cadastro_us})</span>
                    </div>
                    <div className="report_group3_boxB_space"></div>
                    <div className="report_group3_boxB_box">
                        <span className="report_group3_boxB_box_label">/Termos</span>
                        <span className="report_group3_boxB_box_qtde1">{box1.termos_us}</span>
                        <span className="report_group3_boxB_box_qtde2">({box1.termos_us})</span>
                    </div>
                    <div className="report_group3_boxB_space"></div>
                </div>
                </>
                )}
                </div>
                <div className="report_group3_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group4_space"></div>
                <div className="report_box4">
                { loadBox2 ? (<><span>carregando ...</span></>) :
                (<>
                <div className="report_group4_boxA">
                    <span className="report_group4_boxA_title">Cadastro</span>
                    <span className="report_group4_boxA_description">(clientes)</span>
                </div>
                <div className="report_group4_boxB">
                    <div className="report_group4_boxB_box">{box2.clientes}</div>
                </div>
                </>
                )}
                </div>
                <div className="report_group4_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group3_space"></div>
                <div className="report_box3">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                <div className="report_group3_boxA">
                    <div className="report_group5_boxA_space"></div>
                    <div className="report_group5_boxA_label">
                        <span className="report_group4_boxA_title">Agentes e Linhas</span>
                    </div>
                    <div className="report_group5_boxA_space"></div>
                    <div className="report_group5_boxA_box">
                        <span className="report_group4_boxB_title">qtde. de agentes</span>
                        <span className="report_group4_boxB_number">{box2.agentes}</span>
                    </div>
                    <div className="report_group5_boxA_space"></div>
                </div>
                <div className="report_group3_boxB">
                    <div className="report_group5_boxB_space"></div>
                    <div className="report_group5_boxB_box">
                        <span className="report_group4_boxB_title">total de linhas</span>
                        <span className="report_group4_boxB_number">{box2.linhas}</span>
                    </div>
                    <div className="report_group5_boxB_space"></div>
                    <div className="report_group5_boxB_box">
                        <span className="report_group4_boxB_title">linhas livres</span>
                        <span className="report_group4_boxB_number">{box2.ln1}</span>
                    </div>
                    <div className="report_group5_boxB_space"></div>
                </div>
                </>
                )}
                </div>
                <div className="report_group3_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Criado</span>
                        <span className="report_group6_boxA_description">(não configurado)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st1}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Não Ativado</span>
                        <span className="report_group6_boxA_description">(falta linha)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box" style={{color: "red"}}>{box2.st2}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Ativado</span>
                        <span className="report_group6_boxA_description">(testes)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st3}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Ativado</span>
                        <span className="report_group6_boxA_description">(assinante)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box" style={{color: "green"}}>{box2.st4}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
            </div>

            <span className="report_space"></span>

            <div className="report_group">
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Bloqueado</span>
                        <span className="report_group6_boxA_description">(consumo)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st5}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Desativado</span>
                        <span className="report_group6_boxA_description">(cliente)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st6}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Desativado</span>
                        <span className="report_group6_boxA_description">(inadimplência)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st7}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
                <div className="report_box6">
                { loadBox1 ? (<><span>carregando ...</span></>) :
                (<>
                    <div className="report_group6_boxA">
                        <span className="report_group6_boxA_label">Desativado</span>
                        <span className="report_group6_boxA_description">(interno)</span>
                    </div>
                    <div className="report_group6_boxB"><div className="report_group6_boxB_box">{box2.st8}</div></div>
                </>
                )}
                </div>
                <div className="report_group6_space"></div>
            </div>

            <span className="space"></span>
            <span className="space"></span>
            <span className="space"></span>

        </div>
    )
}